export const ENV = {
  API_CONSUMER: process.env.REACT_APP_API_CONSUMER,
  BUSINESS_CONSUMER: process.env.REACT_APP_BUSINESS_CONSUMER,
  CDN_URL: process.env.TTF_PUBLIC_CDN_URL,
  DASHBOARD_URL: process.env.TTF_PUBLIC_DASHBOARD_URL
}
